import { linkify } from './linkify';

const HttpUrlPattern = new RegExp(
  '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$',
  'i'
); // fragment locator

const isValidEmail = email => {
  return !!String(email)
    .toLowerCase()
    .match(
      // eslint-disable-next-line max-len
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
export const isValidExactUrl = (str: string) => HttpUrlPattern.test(str);

export const isValidTelUrl = (str: string) => /^tel:[0-9-()+#*]+$/.test(str);

export const containsUrl = (url: string) => url && url[0] !== '#' && linkify.test(url);

export const isValidHref = (value: string) =>
  containsUrl(value) || isValidEmail(value) || isValidTelUrl(value);

export const normalizeHref = (value: string): string | undefined => {
  if (isValidTelUrl(value)) {
    return value;
  }
  const [urlValue, anchor] = value.split('#');
  const normalizedUrl = urlValue && linkify.match(urlValue) && linkify.match(urlValue)?.[0]?.url;

  if (normalizedUrl === null) {
    return undefined;
  }

  return anchor ? `${normalizedUrl}#${anchor}` : normalizedUrl;
};

export const getUrlMatches = (text: string) => linkify.match(text) || [];

export const normalizeUrl = (url: string) => {
  const result = url && linkify.match(url) && linkify.match(url)?.[0];

  if (result && ['http:', 'https:', ''].includes(result.schema)) {
    return result.url;
  }

  return null;
};

export const startsWithHttps = (url: string) => /^https:/.test(url);

const startsWithHttp = (url: string) => /^http:/.test(url);

export const getHost = url =>
  url && !startsWithHttps(url) && !startsWithHttp(url)
    ? new URL(`http://${url}`).host
    : new URL(url).host;

export const hasProtocol = (url: string) => /^[a-z]+:/i.test(url);
